import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $PreviewFeature = styled.div`
  display: flex;
  gap: ${spacing('lg')};

  & > div {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  & > div::first-letter {
    text-transform: capitalize;
  }

  & > div:first-child {
    flex: none;
  }
`;
